<template>
  <div>
    <div :style="{ borderBottom: '1px solid #E9E9E9' }">
      <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
        全选/反选
      </a-checkbox>
    </div>
    <br/>
    <a-checkbox-group v-model="checkedList" :options="plainOptions" @change="onChange"/>
  </div>
</template>
<script>


const plainOptions = [
    {label: '编号', value: 'code'},
    {label: '中文名称', value: 'cn'},
    {label: '英文名称', value: 'en'},
    {label: '拉丁名称', value: 'ld'},
    {label: '中文别名', value: 'nick'},
    {label: 'GEMS编码', value: 'gems'},
    {label: 'FOODEX_2编码', value: 'foodex2'},
    {label: '描述', value: 'remark'}
];
const defaultCheckedList = ['cn', 'nick'];

const allCheckedList=['code', 'cn','en', 'ld','nick', 'gems','foodex2', 'remark'];
import mixin from '../mixin/AExtStringMixin'
export default {
    mixins:[mixin],
    data() {
        return {
            checkedList: defaultCheckedList,
            indeterminate: true,
            checkAll: false,
            plainOptions,
            localValue:''
        };
    },
    methods: {
        onChange(checkedList) {
            this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length;
            this.checkAll = checkedList.length === plainOptions.length;
            this.localValue=checkedList.join(',');
        },
        onCheckAllChange(e) {
            Object.assign(this, {
                checkedList: e.target.checked ? allCheckedList : [],
                indeterminate: false,
                checkAll: e.target.checked,
            });
            if(e.target.checked){
                this.localValue=allCheckedList.join(',');
            }
            else {
                this.localValue='';
            }
        },
    },
};
</script>
